import { useState } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, IconButton,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useDispatch, useSelector } from 'react-redux';
import { updatePlayerName } from 'redux/slices';

export function EditPlayerName({ playerId }) {
  const dispatch = useDispatch();
  const player = useSelector((state) => state.players.find((p) => p.playerId === playerId));
  const [open, setOpen] = useState(false);
  const [name, setName] = useState(player?.playerName || '');

  const handleOpen = () => {
    setName(player?.playerName || '');
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    if (name.trim()) {
      dispatch(updatePlayerName({ playerId, playerName: name.trim() }));
    }
    setOpen(false);
  };

  return (
    <>
      <IconButton size="small" onClick={handleOpen}>
        <EditIcon />
      </IconButton>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Editar nome do jogador</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nome"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSave()}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={handleSave} variant="contained">Salvar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
